import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--line-secondary-n-300, #e0e0e8);
  background: #fff;
`;

export const Section = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #f7f7fa;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const LabelText = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const ValueText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.1px;
  word-wrap: break-word;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  stroke-width: 1px;
  stroke: var(--line-secondary-n-300, #e0e0e8);
  border-top: 1px dashed var(--line-secondary-n-300, #e0e0e8);
`;

